
import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import { ToastContainer, toast } from 'react-toastify';
import CancelIcon from '@mui/icons-material/Cancel';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function ProficiencyAndCapabilities() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const MenuProps1 = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 7,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


    const [open, setOpen] = useState(false);
    const [id, setID] = useState("");
    const [ProficiencyId, setProficiencyId] = useState("");

    const [capabilitiesList, setCapabilitiesList] = React.useState([]);
    const [spinner, setSpinner] = React.useState(false);
    const [Status, setStatus] = useState("1");
    const [CategoryNamesList, setCategoryNamesList] = useState([]);
    const [CategoryId, setCategoryId] = useState("");
    const [SubCategoryNamesList, setSubCategoryNamesList] = useState([]);
    const [SubCategoryId, setSubCategoryId] = useState("");
    const [ProficiencyName, setProficiencyName] = useState("");
    const [SubCategoryName, setSubCategoryName] = useState("");
    const [CategoryName, setCategoryName] = useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [isEdit, setisEdit] = useState("");
    const [State, setState] = useState(false);
    const [State1, setState1] = useState(false);

    const [EditCat, setEditCat] = useState("");
    const [EditSubCat, setEditSubCat] = useState("");

    const handleClickOpen = async (num, data) => {
        setID(num);
        setState(false);
        setState1(false);
        const ProId = num == 1 ? "-1" : data?.proficiencyId;
        const resp = await axios.get("SystemUser/GetDetailsToAddOrUpdateProficiencyCapabilitiies?ProficiencyId=" + ProId);
        setCategoryNamesList(resp?.data?.data?.categoryNamesList);

        const res = await axios.get("SystemUser/GetProficiencySubCategories?category=" + encodeURIComponent(data?.proficiencyCategory) + "&proficiencyId=" + ProId);
        setSubCategoryNamesList(res?.data?.data);

        setProficiencyId(num == 1 ? "-1" : data?.proficiencyId);
        setSubCategoryId(num == 1 ? res?.data?.data[0]?.value : data?.proficiencySubCategroy);
        setCategoryId(num == 1 ? resp?.data?.data?.categoryNamesList[0]?.value : data?.proficiencyCategory);
        setEditCat(num == 2 ? data?.proficiencyCategory : "");
        setEditSubCat(num == 2 ? data?.proficiencySubCategroy : "");
        setStatus(num == 1 ? "1" : data?.status);
        setProficiencyName(num == 1 ? "" : data?.proficiencyName);
        setisEdit(num == 1 ? "" : data?.isEdit);
        setOpen(true);

    };

    const handleClose = () => {
        setOpen(false);
    };

    const [Search, setSearch] = useState("");
    // const FreeSearch = (e) => {
    //     handlePageChange("1");
    //     setSearch(e);
    // }
    const handlePageChange = (event) => {
        setNumber(event);
    };

    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        CapabilitiesList();
    }, [Search, number]);

    async function CapabilitiesList() {
        setSpinner(!spinner);
        axios.get("SystemUser/GetProficiencyCapabilitiesList?freeText=" + Search + "&pageNumber=" + number + "&pageSize=" + 12)
            .then(res => {
                setCapabilitiesList(res?.data?.data);
                setCount(res?.data?.count);
                setSpinner(spinner);
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                setSpinner(spinner);
            })

    }

    const ChangeCategory = async (e) => {
        setCategoryId(e);
        setSubCategoryId("");
        const res = await axios.get("SystemUser/GetProficiencySubCategories?category=" + encodeURIComponent(e));
        setSubCategoryNamesList(res?.data?.data);
    }

    const AddorEdit = async () => {
        if (ProficiencyName != "") {
            const data = {
                "proficiencyId": ProficiencyId,
                "proficiencyCategory": isEdit == true ? EditCat : CategoryId,
                "proficiencySubCategory": isEdit == true ? EditSubCat : SubCategoryId,
                "proficiencyCategoryName": CategoryName == "" ? null : CategoryName,
                "proficiencySubCategoryName": SubCategoryName == "" ? null : SubCategoryName,
                "proficiencyName": ProficiencyName,
                "status": Status == 1 ? true : false,
                "isEdit": ProficiencyId == -1 ? false : true,
                "hasPQReportingData": true,
                "categoryNamesList": null
            }
            const res = await axios.post("SystemUser/AddOrUpdateProficiencyCapability", data);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.data, true);
                handleClose();
                setNumber("1");
                CapabilitiesList();
            } else {
                toastNotify(res?.data?.responseMessage, false);
            }
        } else {
            toastNotify("Please enter mandatory fields", false);
            setOpen(true);
        }

    }
    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    <DialogContent sx={{ padding: "48px 48px" }}>
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: 20,
                            }}
                        >

                            <span style={{ fontSize: "larger" }} >{id == 1 ? " Add Proficiency Capability" : " Edit Proficiency Capability"}</span><br />

                            {id == 1 ? "" : <span style={{ color: "red", fontSize: "16px" }} hidden={isEdit == true}> This Proficiency used in Prequalification </span>}
                        </DialogTitle>

                        <DialogActions >
                            <div>

                                <div className=''>

                                    <div >
                                        <span style={{ color: "#3E4A62" }}>Proficiency Name <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <TextField size='small' sx={{ width: "320px" }} disabled={id == 2} value={ProficiencyName} onChange={(e) => setProficiencyName(e.target.value)} />

                                    </div>
                                    <div className='mt-3'  >
                                        <span style={{ color: "#3E4A62" }}>Category </span>
                                        <br />
                                        <div style={{ display: State == true ? "none" : "block" }}>
                                            <Select
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px",
                                                }}
                                                labelId="demo-multiple-name-label"
                                                value={CategoryId || ""}
                                                id="demo-multiple-name"
                                                size="small"
                                                onChange={(e) => ChangeCategory(e.target.value)}
                                                MenuProps={MenuProps}
                                                disabled={id == 2}
                                            >
                                                {CategoryNamesList?.map((r, i) =>
                                                    <MenuItem key={i} title={r?.text} sx={{ minWidth: "320px" }} value={r?.value}>{r?.text}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='mt-2' hidden={State == false}>
                                        <Stack direction={"row"} spacing={1}>
                                            <TextField size='small' sx={{ width: "280px" }} placeholder="Category name" value={EditCat} onChange={(e) => setEditCat(e.target.value)} />
                                            <Button variant="text" color='error' sx={{ textTransform: "capitalize" }} onClick={() => { setEditCat(CategoryId); setState(false) }}><CancelIcon /></Button>
                                        </Stack>
                                    </div>
                                    <div className='mt-2' hidden={State == true || isEdit == false}>
                                        <Button variant="text" sx={{ textTransform: "capitalize" }} onClick={() => setState(true)}>Edit Category Name</Button>
                                    </div>

                                    <div className='mt-2' hidden={CategoryId == "" || CategoryId != "OTHERS"}>
                                        <TextField size='small' sx={{ width: "320px" }} placeholder="Category name" value={CategoryName} onChange={(e) => setCategoryName(e.target.value)} />
                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>SubCategory  </span>
                                        <br />
                                        <div style={{ display: State1 == true ? "none" : "block" }}>
                                            <Select
                                                sx={{
                                                    '& legend': { display: 'none' },
                                                    '& fieldset': { top: 0 },
                                                    width: "320px"
                                                }}
                                                labelId="demo-multiple-name-label"
                                                value={SubCategoryId || ""}
                                                id="demo-multiple-name"
                                                size="small"
                                                onChange={(e) => setSubCategoryId(e.target.value)}
                                                MenuProps={MenuProps}
                                                disabled={id == 2}

                                            >
                                                {SubCategoryNamesList?.map((r, i) =>
                                                    <MenuItem key={i} title={r?.text} value={r?.value}>{r?.text}</MenuItem>
                                                )}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='mt-2' hidden={State1 == false}>
                                        <Stack direction={"row"} spacing={1}>
                                            <TextField size='small' sx={{ width: "280px" }} placeholder="Subcategory name" value={EditSubCat} onChange={(e) => setEditSubCat(e.target.value)} />
                                            <Button variant="text" color='error' sx={{ textTransform: "capitalize" }} onClick={() => { setEditSubCat(SubCategoryId); setState1(false) }}><CancelIcon /></Button>
                                        </Stack>
                                    </div>
                                    <div className='mt-2' hidden={State1 == true || isEdit == false}>
                                        <Button variant="text" sx={{ textTransform: "capitalize" }} onClick={() => setState1(true)}>Edit SubCategory Name</Button>
                                    </div>
                                    <div className='mt-2' hidden={SubCategoryId == "" || SubCategoryId != "OTHERS"}>
                                        <TextField size='small' sx={{ width: "320px" }} placeholder="Subcategory name" value={SubCategoryName} onChange={(e) => setSubCategoryName(e.target.value)} />
                                    </div>
                                    <div className='mt-3'>
                                        <span style={{ color: "#3E4A62" }}>Status </span>
                                        <br />

                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={Status}
                                                onClick={(e) => setStatus(e?.target?.value)}
                                            >
                                                <FormControlLabel value={1} control={<Radio />} label="Active" />
                                                <FormControlLabel value={0} control={<Radio />} label="Inactive" />

                                            </RadioGroup>
                                        </FormControl>

                                    </div>

                                </div>

                                <DialogActions >
                                    <div className="login-help__buttonContainer mt-4">
                                        <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                        <Button variant="contained" className="login-button-request mx-2" onClick={AddorEdit}>{id == 1 ? "Add " : "Save"}</Button>
                                    </div>

                                </DialogActions>
                            </div >
                        </DialogActions>



                    </DialogContent>
                </Dialog>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3> Proficiency Capabilities List</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <TextField
                            placeholder='Search'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome"
                            }}
                            variant="outlined"
                            size="small"
                            value={Search}
                            onChange={(e) => setSearch(e?.target?.value)}
                        />
                        {/* {!HasScreenPermissions(INFO?.AddProficiencyCapability?.actionName) &&
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                            </div>
                        } */}
                        {(HasPermissions(INFO?.AddProficiencyCapability?.actionName, PER?.ScreenPermissions?.Insert) && HasPermissions(INFO?.ProficiencyCapabilitiesList?.actionName, PER?.ScreenPermissions?.Insert)) &&

                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                            </div>
                        }
                    </Stack >

                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    {capabilitiesList?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : <>
                        <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                            <Table aria-label="customized table">

                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Proficiency Name</span>	</StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Category</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> SubCategory</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Status</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                    </TableRow>
                                </TableHead>


                                {capabilitiesList?.map((r, i) => (
                                    <TableBody key={i}>

                                        <TableRow key={i} >

                                            <StyledTableCell sx={{ width: "27%" }}>
                                                {r?.proficiencyName}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "29%" }} >
                                                {r?.proficiencyCategory}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {r?.proficiencySubCategroy}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "25%" }} >
                                                {r?.status == 1 ? "Active" : "InActive"}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }} >
                                                {(HasPermissions(INFO?.AddProficiencyCapability?.actionName, PER?.ScreenPermissions?.Modify) && HasPermissions(INFO?.ProficiencyCapabilitiesList?.actionName, PER?.ScreenPermissions?.Modify)) &&
                                                    <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r)}>
                                                        <img src={Edit} alt="editicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>
                                        </TableRow>

                                    </TableBody>
                                ))}
                            </Table>
                        </TableContainer>
                    </>}
                </Box >


            </Card >
            <div hidden={capabilitiesList == ""}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}


